import {gql} from '@apollo/client/core';


export const GroupVoucherFragment = gql`
  fragment groupVoucher on GroupVoucherCode {
    code
    redirectTo
    showVatText
    showSuggestedRetailPrice
    delivery
    startDate
    endDate
    deliveryDate
    prices {
      id
      productId
      price
      vismaId
    }
    companyProfile {
      id
      name
      isActive
      primaryColor
      secondaryColor
      imageUrl
      contactProfile {
        id
        name
        telephone
        email
        imageUrl
        title
      }
    }
  }
`;
